import { FIELD_NAMES } from "apps/signup/util/constants";
import { STEPS } from "apps/onboarding/util/constants";
import { FIELDS } from "apps/what_i_want/util/constants";

// map some field values to official names
const _signupFieldNameMap = {
	[FIELD_NAMES.gender]: "Gender",
	[FIELD_NAMES.orientation]: "Orientation",
	[FIELD_NAMES.location]: "Location",
	[FIELD_NAMES.birthday]: "Birthdate",
	[FIELD_NAMES.email]: "Email",
	[FIELD_NAMES.screenname]: "Username",
	[FIELD_NAMES.password]: "Password",
	[FIELD_NAMES.captcha]: "Captcha",
};

const _onboardingFieldNameMap = {
	[STEPS.ESSAY]: "Essay",
	[STEPS.QUESTIONS]: "Questions",
	[STEPS.LIKES]: "Likes",
	[STEPS.PHOTOS]: "Photo",
	[STEPS.QUESTIONS_CONVO]: "Questions Chat",
	[STEPS.QUESTIONS]: "Questions Card",

	// wiw fields
	[FIELDS.LOOKINGFOR]: "Desired Relationship",
	[FIELDS.AGE]: "Desired Age",
	[FIELDS.GENDER]: "Desired Gender",
	[FIELDS.DISTANCE]: "Desired Distance",
	[FIELDS.RELATIONSHIP_STATUS]: "Relationship Status",
	[FIELDS.MONOGAMY]: "Monogamy",
};

const EVENT_NAMES = {
	uploadedPhoto: "uploaded photo",
	voted: "voted on card on doubletake home",
	cardShown: "card shown on doubletake home",
	sentMessage: "sent message",
	boosted: "used boost token",
	questionsSubmitted: "Answered question",

	doubletakeSelectedPhoto: "selected photo on doubletake card",

	matchsearchSelectedMatch: "selected match on search home",

	accountSelectedResetPassword: "Selected Reset Password",

	offboardingStarted: "landed on offboarding",
	offboardingSelectedNext: "selected next on offboarding",
	offboardingCompleted: "completed offboarding",

	smsCodeSentSuccess: "sms code sent",
	smsSelectedResendCode: "selected resend sms code",
	smsCodeVertificationResponse: "sms code verification response",
	smsSelectedEditPhoneButton: "selected edit phone button",
	smsWallShown: "shown sms wall",

	signInSelectedEmailPasswordResponse: "selected sign in with email pwd response",
	signInSelectedFacebook: "selected sign in with facebook",

	onboardingSelectJoinOnDesktop: "Selected Join OkC on desktop home page",
	onboardingSelectedEmail: "selected next on onboarding my email",
	onboardingLandedOnLanding: "Landed on Landing",
	onboardingSmsEntry: "onboarding sms entry",
	onboardingSelectedSignUpOnLanding: "Selected sign up on Landing",
	onboardingSelectedSignInOnLanding: "Selected sign in on Landing",
	onboardingSelectedNextOnGentation: "Selected next on Gentation",
	onboardingSelectedNextOnRegistration1: "Selected next on Registration 1",
	onboardingSelectedJoinOnRegistration2: "Selected Join on Registration 2",
	onboardingSelectedJoinOnFBSignUp: "Selected Join on FB Sign Up",
	onboardingSelectedCreateAccount: "Selected sign up on onboarding my password",
	onboardingRegistered: "Registered",
	onboardingSelectedOnEmail: "Selected next on onboarding my email",
	onboardingSelectedMyMatchInterstitial: "selected next on onboarding about my match interstitial",
	onboardingSelectedAboutMeInterstitial: "selected next on onboarding about me interstitial",

	onboardingSelectedNextOnQuestionIntro: "Selected next on Onboarding Ques Intro",
	onboardingSelectedSkipOnQuestion: "Selected skip on Onboarding Questions Chat",
	onboardingSelectedMyResponseOnQuestion: "Selected My Response on Onboarding Questions Chat",

	onboardingSelectedAcceptedResponseOnQuestion: "Selected Accepted Response on Onboarding Questions Chat",
	onboardingSelectedResponseOnQuestionCard: "Selected My Response on Onboarding Questions Card",
	onboardingQuestionsCardCompleted: "Selected Submit on Onboarding Questions Card",

	onboardingQuestionsCompleted: "Selected Submit on Onboarding Questions Chat",
	onboardingFinishedFunnel: "Finished onboarding funnel",

	savedPreferencesOnMyMatch: "saved preferences on my match",
	selectedMyMatchOnSettingsHome: "selected my match on settings home",

	purchasesSwipedSalesCarouselOnAlistUpsell: "Swiped sales carousel on AList Upsell",
	purchasesSelectedPackageOptionOnTopBar: "Selected package option on top bar on AList Upsell",
	purchasesSelectedPlanOnAlistUpsell: "Selected plan on AList Upsell",
	purchasesSelectedSubscribeOnAlistUpsell: "Selected Subscribe on AList Upsell",
	purchasesSelectedConfirmPurchaseOnBillingInfo: "Selected Confirm purchase on Billing Info",
	purchasesSelectSubscribePaypal: "Selected Subscribe with PayPal on AList Upsell or Billing Info",

	purchasesSelectedPlanOnBoostTokenUpsell: "Selected plan on Boost Token Upsell",
	purchasesSwipedSalesCarouselOnBoostTokenUpsell: "Swiped sales carousel on Boost Token Upsell",

	purchasesSubscribedToIncognito: "Subscribed to Incognito",
	purchasesSelectedPlanOnIncognitoUpsell: "Selected plan on Incognito Upsell",
	purchasesSwipedSalesCarouselOnIncognitoUpsell: "Swiped sales carousel on Incognito Upsell",
	purchasesSelectedSubscribeOnIncognitoUpsell: "Selected Subscribe on Incognito Upsell",
	purchasesViewedLikesUpsell: "viewed likes you upsell",

	selectedPaymentOnCheckout: "selected payment type on checkout",

	profileBlock: "blocked match",
	profileHide: "hid match",
	profileInteraction: "selected interaction button on match profile",
	profileQuestionCategory: "selected questions category on match profile",
	profileReport: "reported match",

	profileEditEssay: "edited essay",
	profileViewedQuestions: "viewed drilldown",
	profileViewedSelfviewQuestions: "viewed question page self view",
	profileSelectedQuestionsFilter: "selected questions filter",
	profilePaginatedQuestions: "loaded questions pagination result",

	promoMobileInlinePromo: "Selected Mobile Inline Promo",
	promoAlistLikesYouUpsellScreen: "Selected CTA on Likes You Upsell Screen",
	promoAlistLikesYouUpsellHeaderPromo: "Selected CTA on Likes You Upsell Header Promo",
	promoAlistSearchResultAd: "Selected CTA on search result ad on Search Home",
	promoAlistSearchFilterInterstitial: "Selected option on Search Filter Interstitial",
	promoAlistYellowLikesUpsell: "Selected CTA on Likes Upsell",
	promoAlistBrowseInvisiblyUpsell: "Selected CTA on Browse Invisibly Upsell",
	promoAlistGetAlistSettings: "Selected Get AList on Settings",
	promoBoostProfileEdit: "Selected Boost CTA on Profile Edit",

	promoAlistSettingsBrowseInvisibly: "Selected AList ad on Settings Privacy",
	promoAlistSettingsIncognito: "Selected Incognito ad on Settings Privacy",

	promoAlistSettingsSubscriptions: "Selected AList CTA on Settings Subscriptions",
	promoIncognitoSettingsSubscriptions: "Selected Incognito CTA on Settings Subscriptions",
	promoBoostSubsSettingsSubscriptions: "Selected Boost Sub CTA on Settings Subscriptions",

	promoBoostMobileProfile: "Selected Boost CTA on Profile Edit",
	promoBoostCarouselSwipe: "Swiped sales carousel on Boost Token Upsell",

	promoIncognitoCarouselSwipe: "Swiped sales carousel on Boost Token Upsell",

	messagesSelectedProfileInMatchList: "selected profile in conversations match list",
	messagesSelectedInboxMessage: "Selected message on Inbox",
	messagesDeleted: "Deleted conversation",
	messagesSent: "Sent message on Conversation",

	poppedOutConversation: "popped-out conversation",
	allowedBrowserNotification: "allowed browser notifications",

	datersChoiceVoteSkipped: "Skipped a category",
	datersChoiceVoteCast: "Cast a vote",
	datersChoiceUserFinish: "Finished the survey",
	datersChoiceUserStart: "Started the survey",
	datersChoicePageLoad: "Landed on Daterschoice",
	datersChoiceResultToggle: "Toggled a category result",
	datersChoiceUserResume: "Left and came back",

	discoveryClickedProfile: "selected profile in discovery",
	discoveryClickedInterestSearch: "selected interest search in discovery",
	discoverySearchedInterest: "searched for interest in discovery",

	viewedIntros: "viewed intros tab",
	viewedProfile: "viewed profile",
	viewedFirstPartyPromo: "viewed first party promo",
	selectedFirstPartyPromo: "selected first party promo",
	viewedRateCard: "viewed rate card",
	selectedPackageOnRateCard: "selected package on rate card",
	selectedConfirmPurchaseOnCheckout: "selected confirm purchase on checkout",
	callbackStatusOnPurchaseTransaction: "call back status on purchase transaction",

	appliedAlistSearchFilter: "applied alist search filter",

	passionsSelectedAddTopics: "selected add topics",

	passionsSelectedTopicToAdd: "selected topic to add",
	passionsSelectedNextOnTopicChoices: "selected next on topic choices",

	passionsAddTopicToProfile: "added topic to profile",
	passionsSelectedTopicToWrite: "selected topic to write",
	passionsSelectedTopicPrompt: "selected topic prompt",

	selectedMyPorfileInUnifiedSettings: "selected my profile in unified settings",
	selectedMyIdealPersonInUnifiedSettings: "selected my ideal person in unified settings",
	selectedAccountSettingsInUnifiedSettings: "selected account settings in unified settings",

	updatedDistanceWiwPreferences: "updated distance wiw preferences",
	updatedAgeRangeWiwPreferences: "updated age range wiw preferences",
	updatedGenderWiwPreferences: "updated gender wiw preferences",
	updatedConnectionsWiwPreferences: "updated connections wiw preferences",

	recaptchaScore: "Score for Recaptcha V3",
	reachedDailyLikes: "reached daily likes limit",
	connectionLayerShown: "connection layer shown",
	votedAfterLikesCapLimit: "voted after likes cap limit",
	paymentLinkLearnMore: "clicked on payment link learn more",
	selectedOptionOnNavBar: "selected option on navbar",

	// discovery question search
	questionSearchQuestionSelected: "question selected in question search",
	questionSearchQuestionApplied: "question search applied",

	selectedSelfProfileDetailsSection: "selected self profile details section",

	selectedSettingsSection: "selected settings section",

	// Vouchers
	voucherViewedModal: "viewed voucher modal",
	voucherSubmitCode: "submit voucher code",
	voucherSelectedSignIn: "selected sign in after inputting voucher code",
	voucherSelectedCreateAccount: "selected create account after inputting voucher code",
	voucherViewedSuccess: "viewed voucher success screen",
	voucherViewedError: "viewed voucher error screen",

	getQuestionsSetGenre(genre) {
		if (genre === null) {
			return "Unset questions category";
		} else {
			return `Set questions category to ${genre}`;
		}
	},

	// some things will be getters
	getOnboardingValidatedField(fieldName) {
		const field = _signupFieldNameMap[fieldName];

		if (field) {
			return `Validated signup field - ${field}`;
		} else {
			return null;
		}
	},

	getOnboardingFailedValidationField(fieldName) {
		const field = _signupFieldNameMap[fieldName];

		if (field) {
			return `Failed to validate signup field - ${field}`;
		} else {
			return null;
		}
	},

	getOnboardingStepEventName(stepName) {
		const eventName = _onboardingFieldNameMap[stepName];

		if (eventName === _onboardingFieldNameMap[STEPS.QUESTIONS_CONVO]) {
			// this one has a special name
			return EVENT_NAMES.onboardingQuestionsCompleted;
		} else if (stepName === STEPS.QUESTIONS) {
			return EVENT_NAMES.onboardingQuestionsCardCompleted;
		} else if (eventName) {
			return `Selected next on Onboarding ${eventName}`;
		} else {
			return null;
		}
	},
};

export default EVENT_NAMES;



// WEBPACK FOOTER //
// ./src/analytics/util/EventNames.js